module.exports = __webpack_public_path__ + "static/media/anticheat.458c4096.PNG";